import type * as React from 'react'
import { cn } from '../../lib/utils.ts'

/**
 * Formulářová pole. Dvě velikosti: `default` pro formuláře, `sm` pro hustá
 * místa (řádky tabulek v Nastavení a Importu), aby se výška neobcházela
 * inline třídou `h-8` na deseti místech.
 *
 * Písmo je na mobilu 16px schválně: Safari na iOS při fokusu pole s menším
 * písmem automaticky přiblíží stránku a už ji nevrátí zpět.
 */
export type ControlSize = 'default' | 'sm'

const SIZE: Record<ControlSize, string> = {
  default: 'h-[var(--control-height)] px-3 sm:text-[length:var(--text-base)]',
  sm: 'h-8 px-2.5 sm:text-[length:var(--text-sm)]',
}

const base =
  'flex w-full min-w-0 rounded-[var(--radius-md)] border border-[var(--input)] bg-[var(--card)] text-base ' +
  'disabled:cursor-not-allowed disabled:opacity-50'

export const Input = ({
  className, inputSize = 'default', ...p
}: React.ComponentProps<'input'> & { inputSize?: ControlSize }) => (
  <input
    className={cn(
      base,
      SIZE[inputSize],
      'placeholder:text-[var(--muted-foreground)]',
      'aria-[invalid=true]:border-[var(--destructive)] aria-[invalid=true]:outline-[var(--destructive)]',
      className,
    )}
    {...p}
  />
)

export const Select = ({
  className, inputSize = 'default', ...p
}: React.ComponentProps<'select'> & { inputSize?: ControlSize }) => (
  <select className={cn(base, SIZE[inputSize], className)} {...p} />
)

export const Label = ({ className, ...p }: React.ComponentProps<'label'>) => (
  <label className={cn('text-[length:var(--text-sm)] font-medium', className)} {...p} />
)
